// extracted by mini-css-extract-plugin
module.exports = {"indBikeParentDiv":"indBike_indBikeParentDiv__25HpF","bikeDetails":"indBike_bikeDetails__2fPpa","subsDetails":"indBike_subsDetails__1X5hM","ratesDiv":"indBike_ratesDiv__1-eVU"};